import { useTonConnectUI } from '@tonconnect/ui-react';
import { useEffect } from 'react';
import { logger } from '@/shared/utils/logger';
import { fetchTonProofPayload } from '../api/walletApi';

export const useTonProofPayload = () => {
  const [tonConnectUI] = useTonConnectUI();

  useEffect(() => {
    const fetchProofPayload = async () => {
      try {
        const payload = await fetchTonProofPayload();

        logger.debug("payload fetched:", payload);

        if (payload) {
          logger.debug("Setting proof payload:", payload);
          tonConnectUI.setConnectRequestParameters({
            state: "ready",
            value: {
              tonProof: payload,
            },
          });
        } else {
          logger.warn("No payload received from backend");
          tonConnectUI.setConnectRequestParameters(null);
        }
      } catch (e) {
        logger.error("Failed to fetch proof payload", e);
        tonConnectUI.setConnectRequestParameters(null);
      }
    };

    fetchProofPayload();
  }, [tonConnectUI]);
};
